module.exports = __webpack_public_path__ + "img/ville-geneve.1652ce79.svg";